<template>
    <router-view></router-view>
</template>

<script>
import Home from "./views/Home.vue";
import Admin from "./views/Admin.vue";
import Login from "./views/Login.vue";

export default {
  name: "app",
  components: {
    Home,
    Admin,
    Login
  }
};
</script>


// WEBPACK FOOTER //
// src/App.vue